import React from "react";


const moduleConstant =(t)=> {
  return {
  moduleTab: [
    {
      tabName: t('manpowerAUC'),
      key: "manpower",
    },
    {
      tabName:  t('leadingIndicatorAUC'),
      key: "bscLead",
    },
    {
      tabName:  t('laggingIndicatorAUC'),
      key: "bscLag",
    },
    {
      tabName:  t('misAnalysisAUC'),
      key: "analysis",
    },
    // {
    //   tabName:  "ESG",
    //   key: "esg",
    // },
    // {
    //   tabName: "ESG",
    //   key: "esgTable",
    // },
    // {
    //   tabName: "GENERAL DATA",
    //   key: "genericTable",
    // },
    {
      tabName: t('assignUserAUC'),
      key: "assign",
    },
    
  ],
  tooltips: {
    manpower: {
      averageManpowerTable: {
        avarage:
          t('tooltipsManpowerAverageManpowerTableAvarage'),
        totalManhour:
          t('tooltipsManpowerAverageManpowerTableTotalManhour'),
        recordInjuries:
          t('tooltipsManpowerAverageManpowerTableRecordInjuries'),
        trfr: (
          <div>
            {t('tooltipsManpowerAverageManpowerTableTrfr')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipsManpowerAverageManpowerTableTrfrSecondMsg')}
              </li>
            </ul>
          </div>
        ),
      },
      manpowerTable: {
        bilEmp:
          t('tooltipsManpowerManpowerTableBilEmp'),
        otherWorkers: t('tooltipsManpowerManpowerTableOtherWorkers'),
      },
      ytd: t('tooltipsManpowerManpowerTableYtd'),
      formInput:
        t('tooltipsManpowerManpowerTableFormInput'),
    },
    leading: {
      source: {
        behReportManger:
          t('tooltipsLeadingSourceBehReportManger'),
        behReportOfficer:
          t('tooltipsLeadingSourceBehReportOfficer'),
        behReportEHS:
          t('tooltipsLeadingSourceBehReportEHS'),
        behReportOthers:
          t('tooltipsLeadingSourceBehReportOthers'),
        totalProactiveBehaveReport:
          t('tooltipsLeadingSourceTotalProactiveBehaveReport'),
        totalReactiveBehaveReport:
          t('tooltipsLeadingSourceTotalReactiveBehaveReport'),
        totalSafeBehaveReport:
          t('tooltipsLeadingSourceTotalSafeBehaveReport'),
        totalUnSafeBehaveReport:
          t('tooltipsLeadingSourceTotalUnSafeBehaveReport'),
        unsafeConditionCriticalEquipmentAuditsGapsIdentifiedA:
          t('unsafeConditionCriticalEquipmentAuditsGapsIdentifiedA'),
        unsafeConditionCriticalEquipmentAuditsGapsClosedA:
          t('tooltipsUnsafeConditionCriticalEquipmentAuditsGapsClosedA'),
        unsafeConditionCriticalEquipmentOtherIdentifiedB:
          t('tooltipsUnsafeConditionCriticalEquipmentOtherIdentifiedB'),
        unsafeConditionCriticalEquipmentOtherClosedB:
          t('tooltipsUnsafeConditionCriticalEquipmentOtherClosedB'),
        reactiveUnsafeConditionIdentifiedC:
          t('tooltipsReactiveUnsafeConditionIdentifiedC'),
        reactiveUnsafeConditionClosedC:
          t('tooltipsReactiveUnsafeConditionClosedC'),
        totalUnsafeConditionIdentifiedABC:
          t('tooltipsTotalUnsafeConditionIdentifiedABC'),
        totalUnsafeConditionClosedABC:
          t('tooltipsTotalUnsafeConditionClosedABC'),
        totalProactiveUnsafeConditionIdentifiedAB:
          t('tooltipsTotalProactiveUnsafeConditionIdentifiedAB'),
        totalProactiveUnsafeConditionClosedAB:
          t('tooltipsTotalProactiveUnsafeConditionClosedAB'),
        "% Night Vigillence Inspection":
          t('tooltipsNightVigillenceInspection'),
      },
      capa: {
        totalCAPAIdentified:
          t('tooltipsCapaTotalCAPAIdentified'),
        totalCAPAClosed:
          t('tooltipsCapaTotalCAPAClosed'),
        totalTracking90Closure: (
          <div>
            {t('tooltipsTotalTracking90ClosureFirstMsg')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipsTotalTracking90ClosureSecondMsg')}
              </li>
            </ul>
          </div>
        ),
      },
      deviation: {
        totalLOTODeviationsReported:
          t('tooltipsTotalLOTODeviationsReported'),
        totalptwDeviationsReported:
          t('tipsTotalptwDeviationsReported'),
      },
      formInput:
        t('tooltipsFormInput'),
    },
    lagging: {
      indicator: {
        nearMiss:
          t('tooltipsnearMiss'),
        firstAIdInjury:
          t('tooltipsFirstAIdInjury'),
        medicalTreatmentCasesReported:
          t('tooltipsMedicalTreatmentCasesReported'),
        lossTimeInjuriesReported:
          t('tooltipsLossTimeInjuriesReported'),
        highCriticalNearmissOccurred:
          t('tooltipsHighCriticalNearmissOccurred'),
        notableIncidentOccurred:
          t(''),
      },
    },
    misAnalysis: {
      misParameter: {
        safeVsUnsafeAct: (
          <div>
            {t('tooltipsSafeVsUnsafeActFirstMsg')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipsSafeVsUnsafeActSecondMsg')}
              </li>
            </ul>
          </div>
        ),
        ucClosureRate: (
          <div>
            {t('tooltipsucClosureRateFirstMsg')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipsucClosureRateSecondMsg')}
              </li>
            </ul>
          </div>
        ),
        cmaClosureRate: (
          <div>
            {t('tooltipscmaClosureRateFirstMsg')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipscmaClosureRateSeconfMsg')}
              </li>
            </ul>
          </div>
        ),
        ptwDeviations: t('tooltipsptwDeviations'),
        lotoDeviations: t('tooltipslotoDeviations'),
        sat: t('tooltipsSat'),
        safetyKaizen: t('tooltipsSafetyKaizen'),
        kaizenReplication: (
          <div>
            {t('tooltipsKaizenReplicationFirstMsg')}
            <ul className="my-2">
              <li className="font-14">
                {t('tooltipsKaizenReplicationSecondMsg')}
              </li>
            </ul>
          </div>
        ),
        permanentSafetyTrainings:
          t('tooltipsPermanentSafetyTrainings'),
        contractorSafetyTrainings:
          t('tooltipsContractorSafetyTrainings'),
        trafr: t('tooltipsTrafr'),
      },
    },
    PPCBasedParameter: (
      <div>
        For Division/Department settings, you can only choose one configuration method:
        <ul className="my-2">
          <li className="font-14">
            * Either <strong>Division-based</strong> reporting
          </li>
          <li className="font-14">
            * Or <strong>Department-based</strong> reporting
          </li>
        </ul>
        Your company must select one of these options—not both.
      </div>
    ),
    costParameter:  (
      <div>
        <ul className="my-2">
          <li className="font-14">
          This cost represents the average expense to resolve a single Unsafe Act or Unsafe Condition.
          </li>
        </ul>
      </div>
    ),
    duedateParameter: (
      <div>
        To enable due date selection, choose one or both of the following options:        <ul className="my-2">
          <li className="font-14">
            * <strong>Manual Selection:</strong> The user sets the due date manually while reporting the UAUC.
          </li>
          <li className="font-14">
            * <strong>Risk-Based Selection:</strong> The system automatically sets the due date based on the risk type and the response time (in hours) configured here.
          </li>
        </ul>
      </div>
    ),
    systemdefaultParameter: (
      <div>
         These fields are mandatory and cannot be disabled for UAUC reporting.          
         <ul>
         <li className="font-14">
            * You can specify the <strong>number of evidences per report</strong>. This sets a limit on how many evidence files a user can upload while reporting a UAUC.
          </li>
        </ul>
      </div>
    ),
    systemdefaultParameter: (
      <div>
         These fields are mandatory and cannot be disabled for UAUC reporting.          
         <ul>
        </ul>
      </div>
    ),
    systemdefaultParameterNM: (
      <div>
         These fields are mandatory and cannot be disabled for NM reporting.          
         <ul>
        </ul>
      </div>
    ),
    systemdefaultParameterIRA: (
      <div>
         These fields are mandatory and cannot be disabled for IRA reporting.          
         <ul>
        </ul>
      </div>
    ),
    divisionAndDepartment: (
      <div>
         Add divisions and their associated departments here. Divisions and departments are interdependent—each division can have multiple departments. All employees are mapped to their respective division and department based on the Employee Master data.          
         <ul>
        </ul>
      </div>
    ),
    reportingParameter : (
      <div>
        To add a field to the NM reporting form, tick its checkbox. To remove it, untick the checkbox. Only the selected fields will appear in the NM reporting form. When you’re done, click Save.         
         <ul>
        </ul>
      </div>
    ),
    reportingParameterIRA : (
      <div>
         To add a field to the IRA reporting form, tick its checkbox. To remove it, untick the checkbox. Only the selected fields will appear in the IRA reporting form. When you’re done, click Save.
         <ul>
        </ul>
      </div>
    ),
    reportingParameterUAUC : (
      <div>
         To add a field to the UAUC reporting form, tick its checkbox. To remove it, untick the checkbox. Only the selected fields will appear in the UAUC reporting form. When you’re done, click Save.
         <ul>
        </ul>
      </div>
    ),
    evidenceParameter: (
      <div>
         <ul>
         <li className="font-14">
            You can specify the <strong>number of evidences per report</strong>. This sets a limit on how many evidence files a user can upload while reporting a UAUC.
          </li>
        </ul>
      </div>
    ),
    nmEvidenceParameter: (
      <div>
         <ul>
         <li className="font-14">
            You can specify the <strong>number of evidences per report</strong>. This sets a limit on how many evidence files a user can upload while reporting a NM.
          </li>
        </ul>
      </div>
    ),
    iraEvidenceParameter: (
      <div>
         <ul>
         <li className="font-14">
            You can specify the <strong>number of evidences per report</strong>. This sets a limit on how many evidence files a user can upload while reporting a IRA.
          </li>
        </ul>
      </div>
    ),
    nmInvestigationSteps: (
      <div className="font-12" style={{fontSize: '14px', lineHeight: '1.6'}}>
      <ul>
        <li className="font-12">
          <strong>Near Miss (NM) Investigation</strong> follows a <strong>three-step process</strong>, which is <strong>pre-configured</strong> in the system.
        </li>
        <li className="font-12">
          These steps ensure consistency in how near miss events are evaluated and addressed.
        </li>
      </ul>

      <div
        style={{
          border: '1px solid #ccc',
          // backgroundColor: '#2d2d2d',
          backgroundColor: '#f5f5f5',
          padding: '12px 16px',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'flex-start',
          marginTop: '12px',
          maxWidth: '500px',
          marginLeft: '30px',
          marginRight: '30px',        
        }}
      >
        <span
          style={{
            fontSize: '18px',
            color: '#ff9800',
            marginRight: '10px',
          }}
        >
          ⚠️
        </span>
        <div style={{ color: '#333', wordBreak: 'break-word', }}>
        <strong>Note:</strong> The investigation steps 
          <strong className="ml-1">cannot be changed or customized.</strong>
        </div>
      </div>
       <ul className="my-2">
       While the steps themselves are fixed, you can configure the following elements:      
          <li className="font-12">
            * <strong>NM Documents:</strong>Upload or manage relevant documents as part of the investigation process.
          </li>
          <li className="font-12">
            * <strong>NM Costing:</strong>Add cost-related details associated with the near miss, configurable through the <strong>Costing Module</strong>.
          </li>
        </ul>
    </div>

    ),
    iraInvestigationSteps: (
      <div
      style={{
        // padding: '10px',
        // margin: '10px',
        borderRadius: '8px',
        // backgroundColor: '#1e1e1e',
        // color: '#f1f1f1',
        fontSize: '14px',
        lineHeight: '1.6',
        maxWidth: '480px',
      }}
    >
      <ul style={{ paddingLeft: '20px', marginBottom: '12px' }}>
        <li style={{ marginBottom: '8px' }}>
          <strong>Accident Investigation</strong> is carried out in
          <strong> five pre-configured steps</strong>. These steps are fixed and
          <strong> cannot be changed</strong>, ensuring a consistent and thorough
          investigation process across all incidents.
        </li>
    
        <li style={{ marginBottom: '8px' }}>
          <strong>What Can Be Configured?</strong>
        </li>
    
        <li style={{ marginBottom: '4px' }}>
          While the steps themselves are locked, you can customize the
          <strong> data fields</strong> collected in each step.
        </li>
    
        <li style={{ marginBottom: '4px' }}>
          • <strong>Tick a checkbox</strong> to exclude it.
        </li>
        <li style={{ marginBottom: '4px' }}>
          • <strong>Untick</strong> to include a field in the investigation steps.
        </li>
    
        <li style={{ marginBottom: '4px' }}>
          • Fields with <strong>grey checkboxes</strong> are system-defined and
          <strong> cannot be changed</strong>.
        </li>
    
        <li>Only the selected fields will appear during the accident investigation process.</li>
      </ul>
    
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '4px' }}>
          <strong>Saving Your Configuration</strong>
        </li>
        <li>
          Once you’ve selected the desired fields for each step, click
          <strong> Save</strong> to apply the changes.
        </li>
      </ul>
    </div>
    

    ),
  },
}};


export default moduleConstant;